import { ProductTokens } from '../types'
import { colors } from './colors'

export const sevennews: ProductTokens = {
    colors,
}
